import { matchPath } from 'react-router-dom';

const ISSUE_LIST_PATH = '/issue';
const INSPECTION_LIST_PATH = '/inspection';

const ISSUE_DETAILS_ROUTE_PATTERN = '/project/:projectId/issue/:issueId/*';
const ISSUE_EVENT_ROUTE_PATTERN =
  '/project/:projectId/issue/:issueId/event/:eventId/*';
const INSPECTION_DETAILS_ROUTE_PATTERN =
  '/project/:projectId/inspection/:inspectionId';
const INSPECTION_EDIT_ROUTE_PATTERN =
  '/project/:projectId/inspection/:inspectionId/edit';
const INSPECTION_CHECKLIST_ROUTE_PATTERN =
  '/project/:projectId/inspection/:inspectionId/checklist/:checklistId/*';
const INSPECTION_TEMPLATE_ROUTE_PATTERN =
  '/project/:projectId/inspectionTemplate/:inspectionTemplateId/*';
const LEGACY_INSPECTION_TEMPLATE_ROUTE_PATTERN = '/inspectionTemplate/*';

export function isIssueListPath(pathname: string): boolean {
  return pathname === ISSUE_LIST_PATH;
}

export function isInspectionListPath(pathname: string): boolean {
  return pathname === INSPECTION_LIST_PATH;
}

export function isIssuesOrInspectionsListPath(pathname: string): boolean {
  return isIssueListPath(pathname) || isInspectionListPath(pathname);
}

export function isIssueDetailsPath(pathname: string): boolean {
  return Boolean(matchPath(ISSUE_DETAILS_ROUTE_PATTERN, pathname));
}

export function isIssueEventPath(pathname: string): boolean {
  return Boolean(matchPath(ISSUE_EVENT_ROUTE_PATTERN, pathname));
}

export function isInspectionDetailsPath(pathname: string): boolean {
  return Boolean(
    matchPath(
      { path: INSPECTION_DETAILS_ROUTE_PATTERN, end: true },
      pathname
    )
  );
}

export function isInspectionEditPath(pathname: string): boolean {
  return Boolean(
    matchPath({ path: INSPECTION_EDIT_ROUTE_PATTERN, end: true }, pathname)
  );
}

export function isInspectionChecklistPath(pathname: string): boolean {
  return Boolean(matchPath(INSPECTION_CHECKLIST_ROUTE_PATTERN, pathname));
}

export function isInspectionTemplatePath(pathname: string): boolean {
  return Boolean(
    matchPath(INSPECTION_TEMPLATE_ROUTE_PATTERN, pathname) ||
      matchPath(LEGACY_INSPECTION_TEMPLATE_ROUTE_PATTERN, pathname)
  );
}

export function isEditPath(pathname: string): boolean {
  return pathname.includes('/edit');
}

export function isCreatePath(pathname: string): boolean {
  return pathname.includes('/create');
}